import React from "react";

export default function ConfirmationModal({
  show,
  onClose,
  onConfirm,
  title = "Are you sure?",
  message = "Please confirm this action.",
  confirmText = "Confirm",
  cancelText = "Cancel",
  variant = "primary", // 'primary', 'danger', 'warning', 'success', etc.
}) {
  if (!show) return null;

  const headerBgClass = `bg-${variant}`;
  const btnClass = `btn btn-${variant}`;

  return (
    <div className="modal fade show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 2000 }}>
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content border-0 shadow-lg">
          <div className={`modal-header ${headerBgClass} text-white`}>
            <h5 className="modal-title fw-bold">{title}</h5>
            <button type="button" className="btn-close btn-close-white" onClick={onClose} aria-label="Close"></button>
          </div>
          <div className="modal-body py-4">
            <p className="mb-0 text-secondary">{message}</p>
          </div>
          <div className="modal-footer bg-light border-0">
            <button type="button" className="btn btn-light px-4" onClick={onClose}>
              {cancelText}
            </button>
            <button type="button" className={`${btnClass} px-4`} onClick={onConfirm}>
              {confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
